import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, map } from 'rxjs';
import { PaginatedRepository, REG_HUB_COMMON_CONFIG, RegHubCommonConfig, OrderListItem } from 'reg-hub-common';

@Injectable({
  providedIn: 'root'
})
export class OrderListRepositoryService extends PaginatedRepository<OrderListItem> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);

    this._baseLink = `${config.rootUrl}/Orders`;
    this._customHeaders = new HttpHeaders()
      .set('Accept', 'application/vnd.reghub.list-item+json');
  }

  public getTopTenFailedOrders(): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders(['failedAutomation', 'exception', 'errorcorrection']);
  }

  public getTopTenManualOrders(): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders(['manualFulfillment']);
  }

  private getTopTenOrders(states: string[]): Observable<{ total: number, resource: OrderListItem[] }> {
    let params = new HttpParams()
      .set('isVisible', true)
      .set('sortColumn', 'OrderStatusUpdatedDate')
      .set('sortDirection', 'desc')
      .set('pageSize', 10)
      .set('pageNumber', 1);

    for (const state of states) {
      params = params.append('status', state);
    }

    return this.http.get<OrderListItem[]>(this._baseLink, this.buildGetOptions(params)).pipe(
      map(response => ({
        total: this.parseResourceCountHeader(response.headers),
        resource: response.body ?? []
      }))
    );
  }
}
